import React from "react";
import { Grid } from "semantic-ui-react";

import HeaderImage from "slides/components/HeaderImage.react";
import Question from "slides/components/Question.react";

export default class DefaultLandscape extends React.Component {
    render() {
        let pageWrapperStyle = { minHeight: "100%" };
        let leftSectionStyle = {
            position: "relative",
            width: "100%",
            height: "100%",
            color: this.props.colors.baseText,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        };
        let rightSectionStyle = {
            height: "100%",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        };
        let headerTextStyle = {
            fontSize: "2em",
            fontWeight: "bold",
            padding: "15px",
        };
        let imageStyle = {
            width: "100%",
        };
        let questionStyle = {
            padding: "15px",
            fontSize: "1.25em",
        };
        let mainSectionStyle = {
            width: "100%",
            padding: "15px",
            fontSize: "1.25em",
        };

        return (
            <Grid style={pageWrapperStyle}>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <div style={leftSectionStyle}>
                            <div className="full-width">
                                {this.props.data.image == null && (
                                    <div style={headerTextStyle}>
                                        {this.props.title}
                                    </div>
                                )}
                                <div style={imageStyle}>
                                    <HeaderImage {...this.props} />
                                </div>
                            </div>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <div style={rightSectionStyle}>
                            <div>
                                <div style={questionStyle}>
                                    <Question {...this.props} />
                                </div>
                                <div style={mainSectionStyle}>
                                    {this.props.mainContent}
                                </div>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}
